// src/routes/ContactViewer.jsx in main repo
import React from "react";

import ContactViewerApp from "../components/pages/ContactViewer";

const ContactViewerPage = () => {
  return <ContactViewerApp />;
};

export default ContactViewerPage;
